import React, { FC } from 'react';
import { Heading } from '../../../../../common';
import { IOuter } from './ListFileThumbnailLabel.types';

export const ListFileThumbnailLabel: FC<IOuter> = ({ label, className }) => (
  <Heading size="extraTiny" className={className}>
    {label}
  </Heading>
);
